import React from "react";
import { Text, TouchableOpacity, View } from "react-native";
import SettingMenuTabComponent from "./SettingMenuTabComponent";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppColors } from "../../utility/AppColors";

const SettingMenuComponent = ({
  tabs,
  selectedTab,
  setSelectedTab,
  styles,
  toggleMenu,
}) => {
  return (
    <View>
      {tabs.map((tab) => (
        <SettingMenuTabComponent
          key={tab.key}
          tab={tab}
          selectedTab={selectedTab}
          onSelectTab={setSelectedTab}
          styles={styles}
          toggleMenu={toggleMenu}
        />
      ))}
    </View>
  );
};

export default SettingMenuComponent;
